module.exports = new __parcel__URL__("logo-open-c.b922d93a.jpg").toString();